export default __webpack_public_path__ + "static/media/aditivos-detalle.7a62d801.png";